import React, { useEffect } from "react";
import { useSelector } from "react-redux";

import ExpandedModal from "frontend/components/fort/mod/core/ExpandedModal";
import PhotoModSingleExpandedUpload from "../PhotoModSingleExpandedUpload";
import PhotoModSlideshowUploads from "../PhotoModSlideshowUploads";
import UploadImage from "frontend/components/fort/mod/photos/components/UploadImage";
import GalleryUploads from "frontend/components/fort/mod/core/ExpandedModal/GalleryUploads";

import { useModal2 } from "core/Modal2";

import { useBatchUploads } from "../../hooks";

const PhotoModExpandedModal = () => {
    const { showModal } = useModal2();

    const {
        isActive: largeImageViewIsActive,
        uploadIds: selectedUploadIds
    } = useSelector(state => state.largeImageView);
    const selectedBatch = useSelector(state => state.selectedBatch);

    const { id: selectedBatchId } = selectedBatch;
    const { currentViewUploadIds } = useBatchUploads(selectedBatchId);

    useEffect(() => {
        if (largeImageViewIsActive) {
            showModal();
        }
    }, [largeImageViewIsActive, currentViewUploadIds]);

    if (!selectedBatchId || !currentViewUploadIds?.length) return null;

    const hasMultipleUploadsSelected = selectedUploadIds.length > 1;
    const uploadIds = hasMultipleUploadsSelected
        ? selectedUploadIds
        : currentViewUploadIds;

    // Determine verbiage based on gallery and number of uploads selected
    const modalTitle = hasMultipleUploadsSelected
        ? `Viewing ${selectedUploadIds.length} selected photos`
        : `Viewing selected photo`;

    if (!uploadIds.length) return null;

    let modalContent = null;

    if (hasMultipleUploadsSelected) {
        modalContent = (
            <GalleryUploads
                uploadIds={uploadIds}
                UploadGraphicComponent={props => (
                    <UploadImage {...props} useThumbnail />
                )}
            />
        );
    } else if (uploadIds.length === 1) {
        modalContent = <PhotoModSingleExpandedUpload uploadId={uploadIds[0]} />;
    } else {
        modalContent = (
            <PhotoModSlideshowUploads
                uploadIds={uploadIds}
                defaultId={selectedUploadIds[0]}
            />
        );
    }

    return <ExpandedModal title={modalTitle}>{modalContent}</ExpandedModal>;
};

export default PhotoModExpandedModal;
